import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory, useParams } from 'react-router-dom'

import { useRecoilValue } from 'recoil'

import {
  Button,
  BUTTON_SIZE_LG,
  BUTTON_VARIANT_PRIMARY,
  PageHeader
} from 'mailup-web-components'

import useMessageSendAction from 'Hooks/useMessageSendAction'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'
import {
  canSendState,
  pageState
} from 'Pages/MessageCheckupLinkCheck/recoil/state/page'
import { notifyParent } from 'mailup-react-helpers'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const { id } = useParams()
  const [redirectUrl] = useRedirectorUrl()

  const { title, isBee } = useRecoilValue(pageState)
  const canSend = useRecoilValue(canSendState)

  useEffect(() => {
    notifyParent('selectMenuItemReact', ['EmailCheckupLinkCheck', redirectUrl])
  }, [redirectUrl])

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Messages' }),
      'data-mu-test': 'breadcrumb-item__messages',
      className: 'test-breadcrumb-item__messages'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Email' }),
      'data-mu-test': 'breadcrumb-item__email',
      className: 'test-breadcrumb-item__email'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Saved' }),
      'data-mu-test': 'breadcrumb-item__saved',
      className: 'test-breadcrumb-item__saved',
      url: '#',
      onClick: () => history.push('/messages/email/saved')
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.EmailCheckup' }),
      'data-mu-test': 'breadcrumb-item__checkup',
      className: 'test-breadcrumb-item__checkup',
      url: '#',
      onClick: () => history.push(`/messages/email/${id}/checkup/summary`)
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.CheckupLinkCheck' }),
      'data-mu-test': 'breadcrumb-item__checkup__link-check',
      className: 'test-breadcrumb-item__checkup__link-check'
    }
  ]

  const menuItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.CheckupSummary' }),
      'data-mu-test': 'topmenu-item__checkup__summary',
      className: 'test-topmenu-item__checkup__summary',
      onClick: () => history.push(`/messages/email/${id}/checkup/summary`)
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.CheckupLinkCheck' }),
      'data-mu-test': 'topmenu-item__checkup__link-check',
      className: 'test-topmenu-item__checkup__link-check',
      isActive: true,
      onClick: () => null
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.CheckupSpamCheck' }),
      'data-mu-test': 'topmenu-item__checkup__spam-check',
      className: 'test-topmenu-item__checkup__spam-check',
      onClick: () => history.push(`/messages/email/${id}/checkup/spamcheck`)
    }
  ]

  // if (!isBee) {
  //   menuItems.push({
  //     label: intl.formatMessage({ id: 'Load.NavMenu.CheckupCodeReview' }),
  //     'data-mu-test': 'topmenu-item__checkup__code-review',
  //     className: 'test-topmenu-item__checkup__code-review',
  //     onClick: () =>
  //       notifyParent('redirectMainFrame', [
  //         `App.aspx#/emailCheckUpCodeReview/${id}`
  //       ])
  //   })
  // }

  const handleSendClick = useMessageSendAction(id)

  const ControlsComponent = () => (
    <Button
      kind={BUTTON_VARIANT_PRIMARY}
      size={BUTTON_SIZE_LG}
      data-mu-test='header-btnSend'
      onClick={handleSendClick}
    >
      {intl.formatMessage({ id: 'Load.MailupCommon.Send' })}
    </Button>
  )

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      menuItems={menuItems}
      ControlsComponent={canSend && ControlsComponent}
      title={title}
      loading={!title}
    />
  )
}

export default Header
